<template>
    <div>
        <v-dialog v-model="dialog" class="w-full md:w-1/2">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit {{ editedItem.customer_name }}</span>
                    <v-spacer></v-spacer>
                    <v-icon @click="close">mdi-close</v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="px-2">
                        <div class="flex flex-wrap justify-between content-center -mx-2 p-8">
                            <div class="w-full md:w-1/4 px-2">
                                <v-text-field outlined v-model="editedItem.customer_name" label="Customer Name" hint="Customer Name"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-text-field outlined v-model="editedItem.uin" label="UIN" hint="UIN"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-text-field outlined v-model="editedItem.permit_number" label="Permit Number" hint="Permit Number"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/4 px-2">
                                <v-select :items="dropdownPermitSeriesOption" outlined v-model="editedItem.permit_series" item-text="text" item-value="value" label="Permit Series"></v-select>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="close"><v-icon>mdi-close</v-icon>Cancel</v-btn>
                    <v-btn :loading="loadingSubmitButton" color="success" @click="save"><v-icon>mdi-check</v-icon>Submit</v-btn>
                </v-card-actions>>
            </v-card>
        </v-dialog>

        <v-card raised>
            <v-card-title>
                Housing Move
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingHousingMove" :headers="headers" :items="housingUsers" :search="search" class="elevation-1">
                    <template v-slot:item.action="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingHousingMove: false,
                loadingSubmitButton: false,
                housingUsers: [],
                dialog: false,
                snack: false,
                snackColor: '',
                snackText: '',
                headers: [
                    { text: 'UIN', align: 'left', sortable: true, value: 'uin',},
                    { text: 'Customer Name', value: 'customer_name' },
                    { text: 'Permit Number', value: 'permit_number' },
                    { text: 'Actions', value: 'action', sortable: false },
                ],
                editedIndex: -1,
                editedItem: {
                    uin: '',
                    customer_name: '',
                    permit_number: '',
                    permit_series: '',
                },
                defaultItem: {
                    uin: '',
                    customer_name: '',
                    permit_number: '',
                    permit_series: '',
                },
                dropdownPermitSeriesOption: [
                    {text: 'East Campus', value: 'E'},
                    {text: 'West Campus', value: 'W'},
                    {text: 'Resident Halls', value: 'R'},
                    {text: 'West Campus', value: 'W'},
                ],
            }
        },
        created() {
            this.fetchhousingUsers();
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            fetchhousingUsers: function () {
                this.loadingHousingMove = true;
                axios.get(this.appURL + '/api/housingmoveusers')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            this.housingUsers = response.data;
                        }
                        this.loadingHousingMove = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingHousingMove = false;
                    });
            },
            save: function() {
                if (this.editedIndex > -1) {
                    //Update
                    this.loadingSubmitButton = true;
                    axios.post(this.appURL + '/api/housingmoveusers/' + this.editedItem.uin, {
                        _method: 'patch',
                        uin: this.editedItem.uin,
                        permit_number: this.editedItem.permit_number,
                        permit_series: this.editedItem.permit_series,
                    }).then((response) => {
                        if(response.status === 200)
                        {
                            this.editedItem.permit_number = response.data.permit.permit_number;
                            Object.assign(this.housingUsers[this.editedIndex], this.editedItem);
                            this.snack = true;
                            this.snackColor = 'success';
                            this.snackText = 'Successfully Updated';
                        }
                        else {
                            this.snack = true;
                            this.snackColor = 'error';
                            this.snackText = 'Oops! Something went wrong!';
                        }
                        this.loadingSubmitButton = false;
                        this.close()
                    }).catch(error => {
                        this.snack = true;
                        this.snackColor = 'error';
                        this.snackText = 'Oops! Something went wrong!';                        this.loadingSubmitButton = false;
                        this.close()
                    });
                }
            },
            editItem (item) {
                this.editedIndex = this.housingUsers.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            close () {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300)
            },
        }
    }
</script>
